import React, { useState } from "react";
import { HiOutlinePencil, HiOutlineTrash, HiXMark } from "react-icons/hi2";
import DeleteModal from "../DeleteModal/index";
import { useIntl } from "react-intl";

const ActionsBar = ({
    editMode,
    setEditMode,
    handleDelete,
    closeModal,
    detailsTrue,
    locale,
    isLoading,
    handleSave,
    is_organizer,
}) => {
    const intl = useIntl();
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const handleToggle = () => {
        if (editMode) {
            setEditMode(false);
        } else {
            setEditMode(true);
        }
    };

    const isDeleteOpen = () => {
        if (showDeleteModal) {
            setShowDeleteModal(false);
        } else {
            setShowDeleteModal(true);
        }
    };

    const editBar = (
        <div className="flex gap-4 ">
            {detailsTrue && !editMode && is_organizer && (
                <button
                    className="block rounded-full hover:bg-gray-100 "
                    onClick={handleToggle}
                >
                    <span className="hidden md:block p-2">
                        {" "}
                        <HiOutlinePencil strokeWidth={2} />
                    </span>
                    <span className="block md:hidden text-lg font-semibold">
                        {intl.formatMessage({ id: "button.edit" })}
                    </span>
                </button>
            )}
            {detailsTrue && !editMode && is_organizer && (
                <button
                    className="hidden md:block rounded-full hover:bg-gray-100"
                    onClick={() => isDeleteOpen()}
                >
                    <span className="hidden md:block p-2">
                        <HiOutlineTrash strokeWidth={2} />
                    </span>
                    <span className="block md:hidden text-lg">
                        {intl.formatMessage({ id: "button.delete" })}
                    </span>
                </button>
            )}
        </div>
    );

    const saveMeeting = editMode && (
        <div className="block md:hidden text-lg text-black font-semibold ">
            <button onClick={handleSave}>
                {" "}
                {intl.formatMessage({ id: "button.save" })}
            </button>
        </div>
    );

    const closeButton = (
        <button
            className="hover:bg-gray-100 rounded-full text-xl"
            onClick={closeModal}
        >
            <span className="hidden md:block p-2">
                <HiXMark strokeWidth={1.4} />
            </span>
            <span className="block md:hidden text-lg text-rose-500">
                {intl.formatMessage({ id: "button.return" })}
            </span>
        </button>
    );

    return (
        <div className="text-gray-600 w-full py-1">
            <div className="flex w-full block md:hidden justify-between pb-4 md:pb-0">
                {closeButton} {editBar} {saveMeeting}
            </div>
            <div className="hidden md:flex justify-end w-full gap-6">
                {editBar}
                {closeButton}
            </div>

            {showDeleteModal && (
                <DeleteModal
                    handleDelete={handleDelete}
                    setShowDeleteModal={isDeleteOpen}
                    locale={locale}
                    isLoading={isLoading}
                />
            )}
        </div>
    );
};

export default ActionsBar;
